import { atom } from "jotai";

export const unassignedPaymentsAtom = atom<number>(0);
